import { ChangeEvent, ChangeEventHandler, HTMLAttributes } from 'react';
import errorIcon from '../../assets/icons/error.png';

import { borderStyleConstants } from '../../constants/borderStyle';
import { useSafeSelector } from '../../hooks/useSafeSelector';

export interface InputViewTwoProps {
  name: string;
  placeholder?: string;
  icon?: JSX.Element;
  label?: string | JSX.Element;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  onFocus?: ChangeEventHandler<HTMLInputElement>;
  onBlur?: ChangeEventHandler<HTMLInputElement>;
  value: string;
  className?: string;
  type?: string;
  maxLength?: number;
  error?: string;
  inputMode?: HTMLAttributes<HTMLElement>['inputMode'];
  autoFocus?: boolean;
  borderStyle?: string;
  disabled?: boolean;
  customStyle?: any;
  max?:number
}

export function InputViewTwo(props: InputViewTwoProps) {
  const {
    name,
    placeholder,
    label,
    onChange,
    onFocus,
    onBlur,
    value,
    maxLength,
    className,
    borderStyle,
    type,
    icon,
    error,
    inputMode,
    autoFocus,
    disabled,
    customStyle,
    max
  } = props;
  const { borderStyle: borderStyleState = borderStyle } = useSafeSelector(
    (state: any) => state.customization
  );
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const regexIsNumber = /^\d+$/;
    const isInputEmpty = value === '';
    if (type === 'tel' && !isInputEmpty && !regexIsNumber.test(value)) {
      return;
    } else {
      onChange && onChange(e);
    }
  };
  return (
    <div className="flex flex-col w-full [&_*]:border-box relative">
      <div
        className={[
          `flex justify-between items-center gap-2 py-2.5 px-3 w-full h-10 relative overflow-hidden border border-gray-300 ${
            borderStyleState === borderStyleConstants.RECTANGULAR
              ? 'rounded-none'
              : 'rounded-lg'
          } bg-white`,
          className,
        ].join(' ')}
        style={customStyle?.input ? customStyle?.input : customStyle}
      >
        {label && (
          <label
            className="w-5 h-5 text-sm flex justify-start items-center whitespace-nowrap text-end"
            htmlFor={name}
          >
            {label}
          </label>
        )}
        <input
          className="w-full !rounded-none border-none focus:outline-none [&::placeholder]:text-[var(--placeholder-color)]"
          style={{
            paddingInlineEnd: '1rem',
            backgroundColor: 'inherit',
            '--placeholder-color': customStyle?.placeholder?.color || '#667085'
          } as React.CSSProperties}
          id={name}
          name={name}
          type={type}
          onChange={handleChange}
          onFocus={onFocus}
          onBlur={onBlur}
          placeholder={placeholder ? placeholder : ''}
          maxLength={maxLength}
          autoComplete="off"
          inputMode={inputMode}
          autoFocus={autoFocus}
          disabled={disabled}
          value={value}
        />
        {icon && icon}
        {error && <img className="w-3 h-3" src={errorIcon} alt="error" />}
      </div>
    </div>
  );
}
